export const config = {
  title: "A G'z Gonzalez Construction | Construcción y Remodelación en Greensboro, GA",
  meta: {
    description:
      "A G'z Gonzalez Construction ofrece servicios profesionales de construcción y remodelación en Greensboro, GA, con un enfoque en calidad, confianza y satisfacción del cliente.",
    keywords: [
      "Construcción",
      "Remodelación",
      "Renovaciones de interiores",
      "Construcción de viviendas",
      "Remodelación de espacios exteriores",
      "A G'z Gonzalez Construction",
      "Greensboro GA",
    ],
    author: "A G'z Gonzalez Construction",
    canonicalUrl: "https://www.agzgonzalezconstruction.com/",
  },
  sections: {
    header: {
      businessName: "A G'z Gonzalez Construction",
    },
    sectionB: {
      heroTitle: "A G'z Gonzalez Construction",
      heroSubtitle: "Construyendo confianza, entregando excelencia en Greensboro, GA",
      learnAboutText: "Descubre nuestros servicios",
      phoneNumber: "7064738172",
      phoneLabel: "(706) 473-8172",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/918746438/photo/construction-residential-new-house-in-progress-at-building-site.jpg?s=612x612&w=0&k=20&c=o66U2sJO45ZgQ6gur4UKVqolyjb-cdXb8RC2PfenSo8=",
      cardData: [
        {
          title: "Trabajo de alta calidad",
          description:
            "Nuestro equipo asegura que cada proyecto sea ejecutado con precisión y cuidado, superando las expectativas de nuestros clientes.",
        },
        {
          title: "Soluciones personalizadas",
          description:
            "Ofrecemos soluciones de construcción y remodelación diseñadas para satisfacer tus necesidades específicas y visión.",
        },
        {
          title: "Apoyo confiable",
          description:
            "Nuestro compromiso con la transparencia y la comunicación abierta hace que tu experiencia sea fluida y sin preocupaciones.",
        },
      ],
      description:
        "A G'z Gonzalez Construction ofrece servicios integrales de construcción y remodelación para satisfacer todas tus necesidades residenciales y comerciales en Greensboro, GA.",
    },
    sectionC: {
      servicesTitle: "Nuestros Servicios",
      servicesDescription:
        "En A G'z Gonzalez Construction, ofrecemos una amplia gama de servicios para garantizar que tus proyectos de construcción y remodelación se manejen con experiencia y precisión.",
      cards: [
        {
          title: "Renovaciones de interiores",
          description:
            "Renueva el interior de tu hogar con diseño y estilo profesional.",
          imageSrc:
            "https://primary.jwwb.nl/unsplash/A1g0oeX29ec.jpg",
          imageAlt: "Renovaciones de interiores",
        },
        {
          title: "Construcción de viviendas",
          description:
            "Construcción de viviendas con atención al detalle y calidad excepcional.",
          imageSrc:
            "https://primary.jwwb.nl/unsplash/CXlls8jm1VI.jpg",
          imageAlt: "Construcción de viviendas",
        },
        {
          title: "Remodelación de espacios exteriores",
          description:
            "Transforma los espacios exteriores de tu hogar para que luzcan como siempre soñaste.",
          imageSrc:
            "https://primary.jwwb.nl/unsplash/ymf4_9Y9S_A.jpg",
          imageAlt: "Remodelación de espacios exteriores",
        },
      ],
    },
    sectionD: {
      aboutTitle: "Sobre Nosotros",
      aboutImage: {
        src: "https://primary.jwwb.nl/unsplash/4zwozQxDbD4.jpg?enable-io=true&enable=upscale&crop=949%2C1280%2Cx486%2Cy0%2Csafe&width=478&height=645",
        alt: "A G'z Gonzalez Construction Team",
      },
      aboutText: [
        "En A G'z Gonzalez Construction, estamos comprometidos a proporcionar soluciones de construcción y remodelación de primer nivel. Ya sea que busques servicios residenciales o comerciales, nuestro equipo capacitado asegura que cada proyecto se maneje con profesionalismo, seguridad y calidad inigualable.",
        "Con años de experiencia, nos hemos convertido en un nombre de confianza en la industria, ofreciendo servicios personalizados diseñados para satisfacer tus requisitos únicos. Desde pequeñas reparaciones hasta grandes renovaciones, entregamos resultados excepcionales que superan las expectativas. ¡Confía en A G'z Gonzalez Construction para hacer realidad tu visión!",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Logo de A G'z Gonzalez Construction",
      businessName: "A G'z Gonzalez Construction",
      contact: {
        phone: "7064738172",
        phoneLabel: "(706) 473-8172",
        email: "joseantoniog210@gmail.com",
        website: "https://www.agzgonzalezconstruction.com/",
        address: "Greensboro, GA USA",
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Greensboro, GA USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.5760110136727!2d-83.182062!3d33.579513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884039afdf85df3d%3A0x73dc541ee2fae5e0!2sGreensboro%2C%20GA!5e0!3m2!1ses!2sus!4v1614123456789!5m2!1ses!2sus",
    },
  },
};

export default config;
